import config from "../constants/config";

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/analytics';

if(!window.firebase) {
  window.firebase = firebase;
}

const firebaseApp = firebase.initializeApp({
  apiKey: config.FIREBASE.API_KEY,
  databaseURL: config.FIREBASE.DB_URL,
  measurementId: config.FIREBASE.MEASUREMENT_ID,
  projectId: config.FIREBASE.PROJECT_ID,
  appId: config.FIREBASE.APP_ID,
});
firebaseApp.auth().setPersistence(firebase.auth.Auth.Persistence.NONE);

export default firebaseApp;
